// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Q-yL","question":"Question_question__Nxdrp","description":"Question_description__2SYvQ"};